import { trimmedNullable } from "web_myplann/Shared/Validation/trimmedNullable";
import { type ZodType, z } from "zod";

const ZIP_PATTERN = /^\d{3} ?\d{2}$/;

export const optionalZipCode = (
	formatMessage: string,
): ZodType<string | null, z.ZodTypeDef, string> =>
	trimmedNullable(
		z
			.string()
			.refine((val) => val === "" || ZIP_PATTERN.test(val), formatMessage),
	);
